export enum DiscountType {
    MultiPolicy = 1,
    AdditionalChildren = 2,
    GeneralProduct = 3
}
